/**
 * Applies palette color overrides from store settings to the theme.
 * Handles primary, secondary, background, surface, text, link, error, success, and warning colors.
 *
 * @param {import('@mui/material/styles').Theme} theme - The base MUI theme
 * @param {Object|null} storeSettings - Store customization settings
 * @returns {Object} Modified theme options object
 */
export const applyPalette = (theme, storeSettings) => ({
    ...theme,
    palette: {
        ...theme.palette,
        primary: {
            main: storeSettings?.webStorePrimaryColour || theme.palette.primary.main,
        },
        secondary: {
            main: storeSettings?.webStoreSecondaryColour || theme.palette.secondary.main,
        },
        background: {
            ...theme.palette.background,
            default: storeSettings?.webStoreBackgroundColour || theme.palette.background.default,
            paper: storeSettings?.webStoreSurfaceColour || theme.palette.background.paper,
        },
        text: {
            ...theme.palette.text,
            primary: storeSettings?.webStoreTextPrimaryColour || theme.palette.text.primary,
            secondary: storeSettings?.webStoreTextSecondaryColour || theme.palette.text.secondary,
        },
        link: theme.palette.augmentColor({
            color: {
                main: storeSettings?.webStoreLinkColour || theme.palette.primary.main,
            },
            name: 'link',
        }),
        error: {
            main: storeSettings?.webStoreErrorColour || theme.palette.error.main,
        },
        success: {
            main: storeSettings?.webStoreSuccessColour || theme.palette.success.main,
        },
        warning: {
            main: storeSettings?.webStoreWarningColour || theme.palette.warning.main,
        },
        info: {
            main: storeSettings?.webStoreInfoColour || theme.palette.info.main,
        },
    },
    components: {
        ...theme.components,
        MuiLink: {
            styleOverrides: {
                root: ({ theme }) => ({
                    color: theme.palette.link.main,
                    textDecorationColor: theme.palette.link.main,
                    '&:hover': {
                        color: theme.palette.link.dark,
                        textDecorationColor: theme.palette.link.dark,
                    },
                }),
            },
        },
    },
})
